export default {
  getStatesByCountry: state => countryId => state.countries[countryId],
};
